import axios from "axios";
import { del, get, post, patch,  put } from "./prestations_api_helper";
import * as url from "./prestations_url_helper";





// Get features
export const getPrestations = () => get(url.GET_PRESTATIONS);


// Add feature
export const addNewPrestation = (prestation) => post(url.ADD_NEW_PRESTATION, prestation);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));




// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updatePrestation = (prestation) => patch(`${url.UPDATE_PRESTATION}/${prestation.id}`,  prestation);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deletePrestation = (prestation) => del(`${url.DELETE_PRESTATION}/${prestation.id}`);







export {
  //getLoggedInUser,
  
  
};
